import React, { useCallback, useState } from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { Card } from 'apps/sigma2-ui/src/components/ui/Card';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { useDashboards } from 'apps/sigma2-ui/src/lib/hooks/useDashboards';
import { useNavigateSafe } from 'apps/sigma2-ui/src/lib/hooks/useNavigateSafe';
import { CircularProgress } from '@mui/material';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const NewDashboardCard = ({ dashboards }: { dashboards: number }) => {
  const { createEmptyDashboard } = useDashboards();
  const language = useLanguage();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigateSafe();

  const handleCreateEmptyDashboard = useCallback(async () => {
    if (isLoading) return;

    setIsLoading(true);

    const dashboard = await createEmptyDashboard();

    if (dashboard) {
      navigate(`/dashboards/${dashboard.id}`);
    }
  }, [createEmptyDashboard, isLoading, navigate]);

  return (
    <Card paddingClassName="py-3 px-5">
      <Spacing
        direction="horizontal"
        size="justify-between"
        className="items-center pl-1"
      >
        <S2Typography
          translatedContent={language.dashboardsShown({ dashboards })}
          variant="body-7"
        />

        <PrimaryButtonLightBg
          onClick={handleCreateEmptyDashboard}
          disabled={false}
          translatedContent={language.newDashboard()}
          icon={() =>
            isLoading ? (
              <CircularProgress
                size={16}
                thickness={4}
                className="text-violet-100"
              />
            ) : undefined
          }
        />
      </Spacing>
    </Card>
  );
};
